import styled, { css } from "styled-components";
import { font } from "src/styles/variables";

export const headingStyles = css`
  font-family: ${font.primary};
  font-style: normal;
  margin-bottom: 10px;
`;

export const h1Styles = css`
  font-size: 26px;
  font-weight: 600;
`;

export const h2Styles = css`
  font-size: 20px;
  font-weight: 600;
`;

export const h3Styles = css`
  font-size: 18px;
  font-weight: 400;
`;

export const H1 = styled.h1`
  ${headingStyles};
  ${h1Styles};
`;

export const H2 = styled.h2`
  ${headingStyles};
  ${h2Styles};
`;

export const H3 = styled.h3`
  ${headingStyles};
  ${h3Styles};
`;
